export default __webpack_public_path__ + "static/media/carlLorySocialNew.f899385a.png";